import { useQuery } from "@tanstack/react-query";

import { getMySubscription } from "@/api";

const useGetSubscription = () => {
  return useQuery({
    queryKey: ["my-subscription"],
    queryFn: getMySubscription,
    refetchOnWindowFocus: false,
    meta: {
      withoutError: true,
    },
  });
};

export { useGetSubscription };
